import { NavLink } from "react-router-dom"
import HasPermission, { CanManageBusinessUnit } from "../../../../app/PermissionChecker"

function BusinessUnitNav({businessUnit}) {

    const canManageBusinessUnit = HasPermission(CanManageBusinessUnit)

    return (
        <div className="col mb-2">
            <div className="btn-group ">
                <NavLink to="/dashboard/businessUnits/detail" state={businessUnit} className={"btn btn-primary"}><i className="fa-solid fa-eye"></i> Dashboard</NavLink>

                {
                    canManageBusinessUnit &&
                    <>
                        <a href="" className="btn btn-success disabled"><i className="fa-solid fa-bolt"></i> Manage</a>
                        <NavLink to="/dashboard/businessUnits/edit" state={businessUnit.guid} className={"btn btn-dark"}><i className="fa-solid fa-gear"></i> Settings</NavLink>
                    </>
                }

            </div>
        </div>
    )
}

export default BusinessUnitNav